<template>
  <div class="d-inline-block">
    <span v-if="live">{{ tShow | format }}</span>
    <span v-else>{{ time | format }}</span>
  </div>
</template>

<script>
export default {
  name: "Clock",
  props: ['time', 'live'],
  data() {
    return {
      tShow: 0,
      interval: null,
    }
  },

  mounted() {
    if (this.live) {
      this.tShow = parseInt(this.time || '0');
      this.interval = setInterval(() => { this.tShow++ }, 60000);
    }
  },

  filters: {
    format(time) {
      const hour = Math.floor((time || 0) / 60);
      const min = Math.floor(time - (hour * 60));
      return hour < 1 ? `${min}min` : (hour < 24 ? `${`0${hour}`.slice(-2)}` + ':' + `0${min}`.slice(-2) : `${hour}h`);
    }
  },

  beforeDestroy() {
    clearInterval(this.interval);
  }
}
</script>

<style scoped>
div {
  font-variant-numeric: tabular-nums;
}
</style>